import axios from "axios";
import config from "@/config"
import {reportError} from "@/utils/util";
import qs from "qs";

const endpoint = config.api.endpoint;
const deviceId = localStorage.getItem('deviceId');
const appVersion = localStorage.getItem('appVersion');

const headers = {
    'Content-Type': 'application/json',
    "X-App-Version": appVersion,
    "appVersion": appVersion,
    "X-Device-Id": deviceId,
};

//AxiosRequestConfig
/**
 * @param apiName
 * @param param {Object}
 * @returns {Promise<ResultDTO<D>>}
 */
async function get(apiName, param){
    try {
        const response = await axios.get(`${endpoint}${apiName}`, {params: param, headers});
        return response.data;
    }catch(e){
        return {success: false, errorMsg: "网络异常,请稍后再试", errorCode: "http.get.exception"}
    }

}

/**
 * @param apiName
 * @param data {Object}
 * @param contentType {string}
 * @returns {Promise<ResultDTO<D>>}
 */
async function post(apiName, data, contentType = 'application/json'){
    try{
        if (contentType === 'application/x-www-form-urlencoded') {
            headers['Content-Type'] = 'application/x-www-form-urlencoded';
            data = qs.stringify(data); // 使用 qs 库格式化数据
        }

        const response = await axios.post(`${endpoint}${apiName}`, data, {headers});

        return response.data;
    }catch (e){
        console.error(e);
        reportError(data, e);
        return {success: false, errorMsg: "网络异常,请稍后再试", errorCode: "http.post.exception"}
    }

}

export {
    get,
    post,
}
